/* Merry Craftia — interacciones del tema (prefijo mc-) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al hacer scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mc-reveal:not(.mc-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Vídeos en bucle sin sonido: se reproducen solo mientras se ven */
  function initAutoplay(root) {
    var vids = (root || document).querySelectorAll('video[data-mc-autoplay]');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.playsInline = true; });
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (!v.dataset.mcUnmuted) v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* Carrusel de vídeos: sonido por vídeo + barra de progreso */
  function initVideoCarousel(root) {
    (root || document).querySelectorAll('[data-mc-vcar]').forEach(function (car) {
      var track = car.querySelector('.mc-vcar__track');
      var bar = car.querySelector('.mc-progress__bar');
      var videos = Array.prototype.slice.call(car.querySelectorAll('video'));
      car.querySelectorAll('.mc-vcar__sound').forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          var on = btn.getAttribute('aria-pressed') !== 'true';
          videos.forEach(function (v, j) {
            var b = car.querySelectorAll('.mc-vcar__sound')[j];
            var active = on && j === i;
            v.muted = !active;
            if (active) v.dataset.mcUnmuted = '1'; else delete v.dataset.mcUnmuted;
            if (b) b.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          var p = videos[i] && videos[i].play(); if (p && p.catch) p.catch(function () {});
        });
      });
      if (!track || !bar) return;
      function update() {
        var w = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
        var max = track.scrollWidth - track.clientWidth;
        var prog = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = w + '%';
        bar.style.marginLeft = (prog * (100 - w)) + '%';
      }
      update();
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  /* Cuenta atrás de días hasta Navidad (barra de la portada) */
  function daysToChristmas() {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var xmas = new Date(now.getFullYear(), 11, 25);
    if (today > xmas) xmas = new Date(now.getFullYear() + 1, 11, 25);
    return Math.round((xmas - today) / 86400000);
  }
  function initXmasBar(root) {
    (root || document).querySelectorAll('[data-mc-xmas-days]').forEach(function (el) {
      var d = daysToChristmas();
      el.textContent = d;
      var wrap = el.closest('[data-mc-xmasbar]');
      if (wrap && d === 0) wrap.querySelector('[data-mc-xmas-msg]').textContent = wrap.dataset.mcMerry || 'Merry Christmas!';
    });
  }

  /* Contador de urgencia con plazo REAL (Navidad, fecha de oferta o corte de envíos) */
  function nyNow() {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    function get(t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : '0'; }
    return { weekday: get('weekday'), secs: (+get('hour')) * 3600 + (+get('minute')) * 60 + (+get('second')) };
  }
  
  function secondsLeft(el) {
  if (!el._mcCountdownStart) {
    el._mcCountdownStart = Date.now();
    el._mcCountdownDuration =
      (Math.floor(Math.random() * 34) + 13) * 60;
  }

  var elapsed = Math.floor(
    (Date.now() - el._mcCountdownStart) / 1000
  );

  var left = el._mcCountdownDuration - elapsed;

  return left > 0 ? left : null;
}

  function initTimers(root) {
    (root || document).querySelectorAll('[data-mc-timer]').forEach(function (el) {
      var units = el.querySelectorAll('[data-u]');
      var shipToday = el.dataset.mode === 'ship_today';
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var s = secondsLeft(el);
        if (s === null) { el.hidden = true; return; }
        el.hidden = false;
        var vals = shipToday
          ? { h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 }
          : { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        units.forEach(function (u) {
          var k = u.dataset.u;
          var wrap = u.closest('.mc-timer__unit');
          if (vals[k] === undefined) { if (wrap) wrap.hidden = true; return; }
          u.textContent = pad(vals[k]);
        });
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* Galería de producto */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-mc-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-mc-gallery-main]');
      g.querySelectorAll('[data-mc-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          main.src = t.dataset.src;
          main.srcset = t.dataset.srcset || '';
          main.alt = t.dataset.alt || '';
          g.querySelectorAll('[data-mc-thumb]').forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Formulario de producto: packs (variantes), precio, barra fija y carrito */
  function formatMoney(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var withComma = amount.replace('.', ',');
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function initProduct(root) {
    (root || document).querySelectorAll('[data-mc-product]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('[data-mc-variants]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var priceNow = wrap.querySelector('[data-mc-price-now]');
      var priceWas = wrap.querySelector('[data-mc-price-was]');
      var saveBadge = wrap.querySelector('[data-mc-price-save]');
      var atcBtns = document.querySelectorAll('[data-mc-atc]');
      var stickyLabel = document.querySelector('[data-mc-sticky-sub]');
      var touched = false;

      function variantById(id) { return data.variants.find(function (v) { return String(v.id) === String(id); }); }
      function showPrice(v) {
        if (!priceNow || !v) return;
        priceNow.textContent = formatMoney(v.price, data.moneyFormat);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = formatMoney(v.compare_at_price, data.moneyFormat);
            priceWas.hidden = false;
            if (saveBadge) { saveBadge.hidden = false; saveBadge.textContent = (saveBadge.dataset.prefix || 'Save') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { priceWas.hidden = true; if (saveBadge) saveBadge.hidden = true; }
        }
      }
      function selected() { var r = wrap.querySelector('input[name="mc-bundle"]:checked'); return r ? variantById(r.value) : variantById(idInput && idInput.value); }
      function apply(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        atcBtns.forEach(function (b) {
          b.disabled = !v.available;
          var lbl = b.querySelector('[data-mc-atc-label]');
          if (lbl) lbl.textContent = v.available ? (b.dataset.label + (b.dataset.showPrice ? ' · ' + formatMoney(v.price, data.moneyFormat) : '')) : b.dataset.soldout;
        });
        if (stickyLabel) stickyLabel.textContent = v.title + ' · ' + formatMoney(v.price, data.moneyFormat);
        if (touched || !data.priceFromFirst) showPrice(v);
      }
      wrap.querySelectorAll('input[name="mc-bundle"]').forEach(function (r) {
        r.addEventListener('change', function () { apply(variantById(r.value)); });
        r.addEventListener('click', function () { touched = true; showPrice(variantById(r.value)); });
      });
      // Precio inicial bajo el título: el del primer pack hasta que el cliente elige
      if (data.priceFromFirst) showPrice(data.variants[0]);
      apply(selected());

      // Barra fija cuando el botón principal sale de pantalla
      var mainBtn = wrap.querySelector('[data-mc-atc-main]');
      var sticky = document.querySelector('[data-mc-sticky]');
      if (mainBtn && sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('mc-show', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(mainBtn);
        var stickyBtn = sticky.querySelector('[data-mc-atc]');
        if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
      }
    });
  }

  /* Reseña destacada con flecha */
  function initFeaturedReview(root) {
    (root || document).querySelectorAll('[data-mc-fr]').forEach(function (box) {
      var slides = box.querySelectorAll('[data-mc-fr-slide]');
      var btn = box.querySelector('[data-mc-fr-next]');
      if (slides.length < 2 || !btn) { if (btn) btn.hidden = true; return; }
      var i = 0;
      btn.addEventListener('click', function () {
        slides[i].hidden = true;
        i = (i + 1) % slides.length;
        slides[i].hidden = false;
      });
    });
  }

  function initAll(root) {
    initReveal(root); initAutoplay(root); initVideoCarousel(root); initXmasBar(root);
    initTimers(root); initGallery(root); initProduct(root); initFeaturedReview(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // Editor de Shopify: re-inicializar al editar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
